import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

export const SUPPORTED_CONTENT_CATEGORIES = {
  webwinkel: "webwinkel",
  "e-commerce": "webwinkel",
  boekhouden: "boekhouden",
  bookkeeping: "boekhouden",
  crm: "crm",
  kassa: "kassa",
  "point-of-sale": "kassa",
  betalingen: "betalingen",
  payments: "betalingen"
};


@Component({
  standalone: false,
  selector: 'app-apps',
  templateUrl: './apps.component.html'
})
export class AppsComponent implements OnInit {

  contentCategory: string;
  language: string;

  constructor(private route: ActivatedRoute,
              private translate: TranslateService) {
  }

  async ngOnInit(): Promise<void> {
    this.language = this.translate.getCurrentLang();
    this.contentCategory = SUPPORTED_CONTENT_CATEGORIES[this.route.snapshot.params["category"]];
  }
}
